// import { useEffect } from "react";
// import Header from "../components/Header";
// import Footer from "../components/Footer";

// function Contract() {
//   useEffect(() => {
//     // Initialize EmailJS safely (after component mounts)
//     if (window.emailjs) {
//       window.emailjs.init("YOUR_PUBLIC_KEY");
//     }

//     const form = document.getElementById("contactForm");
//     const successMessage = document.getElementById("successMessage");

//     const handleSubmit = (e) => {
//       e.preventDefault();

//       window.emailjs
//         .sendForm("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", form)
//         .then(() => {
//           successMessage.classList.remove("hidden");
//           form.reset();

//           setTimeout(() => {
//             successMessage.classList.add("hidden");
//           }, 3000);
//         })
//         .catch((error) => {
//           alert("Message failed to send");
//           console.error(error);
//         });
//     };

//     form?.addEventListener("submit", handleSubmit);

//     return () => {
//       form?.removeEventListener("submit", handleSubmit);
//     };
//   }, []);

//   return (
//     <div className="bg-black text-white">
//       <Header className="relative z-20" />
//       {/* Hero Section */}
//       <section className="relative h-[50vh]  flex items-center justify-center">
//         <img
//           src="https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=1600"
//           alt="Bike"
//           className="absolute inset-0 w-full h-full object-cover"
//         />
//         <div className="absolute inset-0 bg-black/70"></div>

//         <div className="relative z-10 text-center px-6">
//           <h1 className="text-5xl md:text-7xl font-bold uppercase">
//             Contact Us
//           </h1>
//           <p className="mt-4 text-lg text-gray-300">
//             We&apos;d love to hear from you.
//           </p>
//         </div>
//       </section>

//       {/* Contact Section */}
//       <section className="py-20">
//         <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12">
//           {/* Left Info */}
//           <div>
//             <span className="text-lime-400 uppercase tracking-[4px] font-semibold">
//               Get In Touch
//             </span>

//             <h2 className="text-4xl md:text-5xl font-bold mt-4">
//               Let&apos;s Talk About Your Bike Cable Needs
//             </h2>

//             <p className="text-gray-400 mt-6 leading-relaxed">
//               Whether you need product information, custom cable solutions, or
//               technical support, our team is ready to help.
//             </p>

//             <div className="mt-10 space-y-6">
//               <div>
//                 <h3 className="text-lime-400 font-bold text-xl">Address</h3>
//                 <p className="text-gray-300 mt-2">
//                   Near Burger King, Opposite Shiv Mandir, JhaJhanpur
//                   <br />
//                   Moradabad, Uttar Pradesh - 244001
//                 </p>
//               </div>

//               <div>
//                 <h3 className="text-lime-400 font-bold text-xl">Phone</h3>
//                 <p className="text-gray-300 mt-2">+91 98765 43210</p>
//               </div>

//               <div>
//                 <h3 className="text-lime-400 font-bold text-xl">Email</h3>
//                 <p className="text-gray-300 mt-2">info@bikecable.com</p>
//               </div>

//               <div>
//                 <h3 className="text-lime-400 font-bold text-xl">
//                   Working Hours
//                 </h3>
//                 <p className="text-gray-300 mt-2">
//                   Monday - Saturday: 9:00 AM - 6:00 PM
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Form */}
//           <div className="bg-zinc-900 p-8 rounded-3xl">
//             <form id="contactForm" className="space-y-6">
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Full Name"
//                 required
//                 className="w-full bg-black border border-zinc-700 rounded-lg px-4 py-3 focus:border-lime-400 outline-none"
//               />

//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Email Address"
//                 required
//                 className="w-full bg-black border border-zinc-700 rounded-lg px-4 py-3 focus:border-lime-400 outline-none"
//               />

//               <input
//                 type="tel"
//                 name="phone"
//                 placeholder="Phone Number"
//                 required
//                 className="w-full bg-black border border-zinc-700 rounded-lg px-4 py-3 focus:border-lime-400 outline-none"
//               />

//               <textarea
//                 name="message"
//                 rows="5"
//                 placeholder="Write your message..."
//                 required
//                 className="w-full bg-black border border-zinc-700 rounded-lg px-4 py-3 focus:border-lime-400 outline-none"
//               />

//               <button
//                 type="submit"
//                 className="w-full bg-lime-400 text-black font-bold py-4 rounded-lg hover:bg-lime-300 transition"
//               >
//                 Send Message
//               </button>
//             </form>

//             <p
//               id="successMessage"
//               className="hidden text-lime-400 mt-4 text-center"
//             >
//               Message sent successfully!
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Map */}
//       <section className="pb-20">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="overflow-hidden rounded-3xl">
//             {/* <iframe
//               src="https://maps.google.com/maps?q=Moradabad%20Uttar%20Pradesh%20244001&output=embed"
//               className="w-full h-[450px]"
//               loading="lazy"
//               title="location map"
//             /> */}
//             <iframe
//               src="https://maps.google.com/maps?q=Near%20Burger%20King%2C%20Opposite%20Shiv%20Mandir%2C%20JhaJhanpur%2C%20Moradabad%2C%20Uttar%20Pradesh%20244001&output=embed"
//               className="w-full h-[450px]"
//               loading="lazy"
//               title="location map"
//             />
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// }

// export default Contract;

import Header from "../components/Header";
import Footer from "../components/Footer";

function Contract() {
  const handleSubmit = (e) => {
    e.preventDefault();

    const name = e.target.name.value;
    const email = e.target.email.value;
    const phone = e.target.phone.value;
    const message = e.target.message.value;

    const subject = encodeURIComponent("New Contact Form Message");

    const body = encodeURIComponent(
      `Name: ${name}
Email: ${email}
Phone: ${phone}
Message: ${message}`,
    );

    window.location.href = `mailto:superstrengcable@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="bg-black text-white">
      <Header className="relative z-20" />

      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center">
        <img
          src="https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=1600"
          alt="Bike"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70"></div>

        <div className="relative z-10 text-center px-6">
          <h1 className="text-5xl md:text-7xl font-bold uppercase">
            Contact Us
          </h1>
          <p className="mt-4 text-lg text-gray-300">
            We&apos;d love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12">
          {/* Left Info */}
          <div>
            <span className="text-lime-400 uppercase tracking-[4px] font-semibold">
              Get In Touch
            </span>

            <h2 className="text-4xl md:text-5xl font-bold mt-4">
              Let&apos;s Talk About Your Bike Cable Needs
            </h2>

            <p className="text-gray-400 mt-6 leading-relaxed">
              Whether you need product information, custom cable solutions, or
              technical support, our team is ready to help.
            </p>

            <div className="mt-10 space-y-6">
              <div>
                <h3 className="text-lime-400 font-bold text-xl">Address</h3>
                <p className="text-gray-300 mt-2">
                  Near Burger King, Opposite Shiv Mandir, JhaJhanpur
                  <br />
                  Moradabad, Uttar Pradesh - 244001
                </p>
              </div>

              <div>
                <h3 className="text-lime-400 font-bold text-xl">Phone</h3>
                <p className="text-gray-300 mt-2">+91 98765 43210</p>
              </div>

              <div>
                <h3 className="text-lime-400 font-bold text-xl">Email</h3>
                <p className="text-gray-300 mt-2">info@bikecable.com</p>
              </div>

              <div>
                <h3 className="text-lime-400 font-bold text-xl">
                  Working Hours
                </h3>
                <p className="text-gray-300 mt-2">
                  Monday - Saturday: 9:00 AM - 6:00 PM
                </p>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="bg-zinc-900 p-8 rounded-3xl">
            <form onSubmit={handleSubmit} className="space-y-6">
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                required
                className="w-full bg-black border border-zinc-700 rounded-lg px-4 py-3 focus:border-lime-400 outline-none"
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                required
                className="w-full bg-black border border-zinc-700 rounded-lg px-4 py-3 focus:border-lime-400 outline-none"
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                required
                className="w-full bg-black border border-zinc-700 rounded-lg px-4 py-3 focus:border-lime-400 outline-none"
              />

              <textarea
                name="message"
                rows="5"
                placeholder="Write your message..."
                required
                className="w-full bg-black border border-zinc-700 rounded-lg px-4 py-3 focus:border-lime-400 outline-none"
              />

              <button
                type="submit"
                className="w-full bg-lime-400 text-black font-bold py-4 rounded-lg hover:bg-lime-300 transition"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="overflow-hidden rounded-3xl">
            <iframe
              src="https://maps.google.com/maps?q=Near%20Burger%20King%2C%20Opposite%20Shiv%20Mandir%2C%20JhaJhanpur%2C%20Moradabad%2C%20Uttar%20Pradesh%20244001&output=embed"
              className="w-full h-[450px]"
              loading="lazy"
              title="location map"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Contract;
